module.exports = __webpack_public_path__ + "media/images/custom_page/bae173/iPhone-cbea2101737cd4901c443763aabceba4.svg";